import React from 'react';
import { useSelector } from 'react-redux';

import StrokeImage from '../../assets/images/death_reasons/strokeImage';
import StrokeEng from '../../assets/images/death_reasons/strokeEng';
import StrokeRus from '../../assets/images/death_reasons/strokeRus';
import Border from '../../assets/images/border';

import './stroke.scss';

const Cancer = () => {
    const { language } = useSelector(state => state.user);

    return (
        <div className='stroke'>
            <Border />
            {language === 'ENG' ? <StrokeEng /> : <StrokeRus />}
            <StrokeImage />
            <span className='stroke-text'>
                {language === 'RUS' ? 'Инсульт — одна из ведущих причин смерти в мире, даже при здоровом образе жизни. Ежегодно регистрируется от 15 до 20 миллионов новых случаев инсульта. Контролируйте давление и сахар.' : 'Stroke is one of the leading causes of death worldwide, even with a healthy lifestyle. Annually, 15 to 20 million new cases of stroke are registered. Monitor your blood pressure, sugar levels, and regularly check your cardiovascular health or vascular system.'}
            </span>
        </div>
    );
};

export default Cancer;